import { createSelector } from 'reselect';
import get from 'lodash/get';
import pick from 'lodash/pick';

const playerInternalSizesSelector = (state) => get(state, 'playerinternal.sizes');

export const videoPlayerSizesSelector = createSelector(
  playerInternalSizesSelector,
  (sizes) => pick(sizes, ['playerHeight', 'playerWidth']),
);

export const videoSelector = createSelector(
  playerInternalSizesSelector,
  (sizes) => pick(sizes, ['videoHeight', 'videoWidth']),
);
